import React from 'react';
import Layout from '../../../components/Layout.jsx';
import SalesRepForm from './_Form.jsx';

export default function SuperadminSalesRepsNew({ sales_rep }) {
  return (
    <Layout>
      <div className="max-w-xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-gray-900">Add sales rep</h1>
          <p className="mt-1 text-sm text-gray-500">
            They'll be able to create deals and see their own — nothing else in superadmin.
            You'll get a login link to send them once they're saved.
          </p>
        </div>

        <SalesRepForm salesRep={sales_rep} submitPath="/superadmin/sales_reps" submitLabel="Add sales rep" />
      </div>
    </Layout>
  );
}
